import React, { FC } from 'react';
import { CreateFolderForm } from './form/CreateFolderForm';
import { FoldersDropdownCreateText } from './text/FoldersDropdownCreateText';
import { FoldersDropdownCreateContainer } from './content-container/FoldersDropdownCreateContainer';

type Props = {
  onFolderCreate: ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => void;
};

export const FoldersDropdownCreate: FC<Props> = ({ onFolderCreate }) => (
  <FoldersDropdownCreateContainer>
    <CreateFolderForm onFolderCreate={onFolderCreate} />
    <FoldersDropdownCreateText />
  </FoldersDropdownCreateContainer>
);
